import { get } from 'stash/utils';

export const selectIsAuthenticated = (state) => {
	return Boolean(get(state, 'entities.api_key.access_token'));
};

export const selectUUID = (state) => {
	return get(state, 'entities.api_key.uuid');
};

export const selectRefreshTokenPending = (state) => {
	return get(state, 'application.refreshTokenPending');
};
